import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const StatisticsPage = lazy(() => import('./index'));

function StatisticsPageLazy(props) {
    return (
        <Suspense fallback={<Loader/>}>
            <StatisticsPage {...props} />
        </Suspense>
    );
}

export default StatisticsPageLazy;
export { StatisticsPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/statistics-page-old/lazy.js